// Angular
import { Injectable } from '@angular/core';

// Ionic library
import { Platform } from '@ionic/angular';

// Third party library
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Geolocation } from '@capacitor/geolocation';

@Injectable()
export class GeoLocationService {

  constructor(private platform: Platform) { }

  async getLocation():
    Promise<{ latitude: number; longitude: number } |
      {status: boolean, msg: string, showDeviceSetting: boolean}> {
    // Promise<{ latitude: number; longitude: number } | false> {
    try {
      const result = await Geolocation.getCurrentPosition({
        enableHighAccuracy: true,  // Ensures fine location is used
        // timeout: 10000, // Timeout after 10 seconds
        // maximumAge: 0 // Do not use cached location, always get fresh location
      });

      // threshold
      // if (result.coords.accuracy > 50) {
      //   return {
      //     msg: 'Location accuracy is too low. Please enable precise location.',
      //     status: false,
      //     showDeviceSetting: true
      //   };
      // }

      return {
        latitude: result.coords.latitude,
        longitude: result.coords.longitude
      };
    } catch (err) {
      // console.error('Error getting location.', err);
      // return false;
      return {
        msg: 'Error getting location. Reach out support for help.',
        status: false,
        showDeviceSetting: false
      };
    }
  }

  /**
   * @param skipPermissionRequest True to skip prompt, mainly use for geolocation interval
   */
  async askPermissionGeoLocation(skipPermissionRequest = false):
    Promise<{ latitude: number; longitude: number } |
      {status: boolean, msg: string, showDeviceSetting: boolean}> {
    // Promise<{ latitude: number; longitude: number } | false> {
    if (this.platform.is('hybrid')) {
      return await this.checkPermissionGeoLocationNative(skipPermissionRequest);
    }
    else {
      return await this.checkPermissionGeoLocationWeb(skipPermissionRequest);
    }

    // browser old
    // if (!navigator.geolocation) return;
    // navigator.geolocation.getCurrentPosition( (geo) => {
    //   this.clientGeo.latitude = geo.coords.latitude;
    //   this.clientGeo.longitude = geo.coords.longitude;
    // });
  }

  private async checkPermissionGeoLocationNative(skipPermissionRequest: boolean):
    Promise<{ latitude: number; longitude: number } |
      {status: boolean, msg: string, showDeviceSetting: boolean}> {
    // Promise<{ latitude: number; longitude: number } | false> {
    try {
      const permissionStatus = await Geolocation.checkPermissions();

      if (permissionStatus.location === 'granted') {
        return this.getLocation();
      }
      else {
        if (skipPermissionRequest) {
          return {
            msg: '',
            status: false,
            showDeviceSetting: false
          };
        }

        const permissionResult = await Geolocation.requestPermissions({
          permissions: ['location']
        });

        if (permissionResult.location === 'granted') {
          return this.getLocation();
        }
        else {
          // console.log('Geolocation permission denied.');
          // return false;
          return {
            msg: 'Error on granting permission. Open device settings?',
            status: false,
            showDeviceSetting: true
          };
        }
      }
    } catch (err) {
      // console.error('Error checking geolocation permission.', err);
      // return false;
      return {
        msg: 'Error on granting permission. Open device settings?',
        status: false,
        showDeviceSetting: true
      };
    }
  }

  private async checkPermissionGeoLocationWeb(skipPermissionRequest: boolean):
    Promise<{ latitude: number; longitude: number } |
      {status: boolean, msg: string, showDeviceSetting: boolean}> {
    // Promise<{ latitude: number; longitude: number } | false> {
    try {
      const permissionStatus = await Geolocation.checkPermissions();

      if (permissionStatus.location === 'granted' || permissionStatus.location === 'prompt') {
        return this.getLocation();
      }
      // console.log('Geolocation permission not granted.');
      // return false;
      return {
        msg: 'Web: Error on granting permission. Reach out support for help.',
        status: false,
        showDeviceSetting: false
      };
    } catch (err) {
      // console.error('Error checking permission.', err);
      // return false;
      return {
        msg: 'Web: Error on granting permission. Reach out support for help.',
        status: false,
        showDeviceSetting: false
      };
    }
  }
}
